import { InboxOutlined } from '@ant-design/icons'
import { message, Upload } from 'antd'
import { useState, useContext } from 'react'
import API_ENDPOINTS from '../apiConfig'
import { UserContext } from './UserContext';

const Drag = ({ selectedCollectionKey, handleRefresh }) => {
  const { Dragger } = Upload
  const [collectionId] = useState([])
  const { uid } = useContext(UserContext);
  const { token } = useContext(UserContext);

  const props = {
    name: 'files',
    multiple: true,
    action: `${API_ENDPOINTS.collectionsUpload}/docs/trigger?user_id=${uid}&collection_id=${selectedCollectionKey}`,
    headers: { Authorization: `Bearer ${token}` },
    onChange(info) {
      const { status } = info.file
      if (status !== 'uploading') {
        console.log(collectionId)
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        message.success( `${ info.file.name } file sent to queue successfully. Check Collection Content for status.` )
        handleRefresh(selectedCollectionKey)
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
      console.log(collectionId)
    },
  }
  return (
    <div className="drag">
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">Support for a single or bulk upload.</p>
      </Dragger>
    </div>
  )
}
export default Drag